import { JSX } from "react";
import { useParams } from "react-router-dom";

import { useGetContentDetailPage } from "@/hooks/api/content.hooks";

import MovieBannerPlayerMobile from "../common/MovieBanner/MovieBannerPlayerMobile";
import MovieBannerTitleMobile from "../common/MovieBanner/MovieBannerTitleMobile";
import MovieBannerTop from "../common/MovieBanner/MovieBannerTop";

const DetailHeroMobile = (): JSX.Element => {
  const { id } = useParams() as { id: string };
  const { data } = useGetContentDetailPage(+id);

  if (!data) {
    return <></>;
  }

  return (
    <>
      <section
        className={
          "detail-hero relative -left-4 hidden aspect-[375/583] w-full overflow-hidden max-md:block max-md:max-h-[630px]  max-md:w-[calc(100%+32px)]"
        }
      >
        <MovieBannerPlayerMobile
          index={1}
          slideNum={1}
          onVideoEnd={() => {}}
          src={data.content.poster_v.large || data.content.poster_h.large}
          videoSrc={data.content.trailers[0]?.trailer_link ?? data.content.teaser_link}
        />
        <MovieBannerTitleMobile
          id={+id}
          genres={data.content.genres}
          country={data.content.country}
          description={data.content.description}
          year={data.content.year}
          age_restrictions={data.content.age_restrictions}
          logo_image_rectangle={data.content.logo_image_rectangle}
          logo_image={data.content.logo_image || ""}
          rating={data.content.rating}
          imdb_rating={data.content.imdb_rating}
          kinopoisk_rating={data.content.kinopoisk_rating}
          is_serial={data.content.is_serial}
          firstSeason={(data.content.seasons && Number(data.content.seasons[0]?.id)) || 0}
        />
        <MovieBannerTop
          distributor={data.content.distributor}
          rating={data.content.rating}
          is_new={data.content.is_new}
        />
      </section>
    </>
  );
};

export default DetailHeroMobile;
